// extracted by mini-css-extract-plugin
export default {"moreButton":"WalletList_moreButton__ecXwp","row":"WalletList_row__SzqFL","pointer":"WalletList_pointer__X1Kw7","tableHeader":"WalletList_tableHeader__p1Xht"};